export default [
  {
    title: '违规时间',
    dataIndex: 'created_at',
    key: 'created_at'
  },
  {
    title: '违规行为',
    dataIndex: 'type_name',
    key: 'type_name'
  }
]
